import { Route, Routes } from 'react-router-dom';

import { Logout } from '~/modules/auth/components/Logout';
import { RefreshAuth } from '~/modules/auth/components/RefreshAuth';
import { SecureRoute } from '~/modules/auth/components/SecureRoute';
import { OktaAuthRouter } from '~/modules/auth/router';
import { ProtectedApp } from '~/ProtectedApp.tsx';

/**
 * Top-level router combining module-level routers
 * Makes sure user is authorized to access ProtectedApp (via SecureRoute)
 */
function AuthRouter() {
  return (
    <Routes>
      <Route path="login/*" element={<OktaAuthRouter />} />
      <Route element={<SecureRoute />}>
        <Route path="logout" element={<Logout />} />
        <Route path="auth/refresh" element={<RefreshAuth />} />

        <Route path="/*" element={<ProtectedApp />} />
      </Route>
    </Routes>
  );
}

AuthRouter.displayName = 'AuthRouter';

export { AuthRouter };
